//首页
import request from '@/plugins/axios'

// 首页-查询
export function queryPageForIndexApi(data) {
    return request({
        url: '/contractReceivePayment/v1.0.0/pageForIndex',
        method: 'post',
        data
    })
}
// 待审核数量
export function getWaitAuditApi(data) {
    return request({
        url: '/idx/v1.0.0/getWaitAudit',
        method: 'post',
        data
    })
}

// 待归档数量
export function getWaitArchiveApi(data) {
    return request({
        url: '/idx/v1.0.0/getWaitArchive',
        method: 'post',
        data
    })
}

// 待查款到账数量
export function getCheckedAndCreditedIntoAccountApi(data) {
    return request({
        url: '/idx/v1.0.0/getCheckedAndCreditedIntoAccount',
        method: 'post',
        data
    })
}

// 合同到期提醒数量
export function getNearExpirationApi(data) {
    return request({
        url: '/idx/v1.0.0/getNearExpiration',
        method: 'post',
        data
    })
}

// 获取年度数据
export function getYearDataApi(data) {
    return request({
        url: '/idx/v1.0.0/getYearData',
        method: 'post',
        data
    })
}

// 获取月度数据
export function getMoonDataApi(data) {
    return request({
        url: '/idx/v1.0.0/getMoonData',
        method: 'post',
        data
    })
}

// 消息分页
export function pageMy(data) {
    return request({
        url: '/msgInfo/v1.0.0/pageMy',
        method: 'post',
        data: data
    })
}

// 消息列表
export function listMy(data) {
    return request({
        url: '/msgInfo/v1.0.0/listMy',
        method: 'post',
        data: data
    })
}
// 未读数量
export function noReadCountMy(data) {
    return request({
        url: '/msgInfo/v1.0.0/noReadCountMy',
        method: 'post',
        data: data
    })
}
// 清除
export function setClear(data) {
    return request({
        url: '/msgInfo/v1.0.0/setClear',
        method: 'post',
        data: data
    })
}
// 设置已读
export function setRead(data) {
    return request({
        url: '/msgInfo/v1.0.0/setRead',
        method: 'post',
        data: data
    })
}
// 全部已读
export function setAllRead(data) {
    return request({
        url: '/msgInfo/v1.0.0/setAllRead',
        method: 'post',
        data: data
    })
}
// 全部清除
export function setAllClear(data) {
    return request({
        url: '/msgInfo/v1.0.0/setAllClear',
        method: 'post',
        data: data
    })
}
